<template>
    <div class="active_invitations_park">
        <v-dialog
                v-model="dialog_errores"
                persistent
                width="400"
        >
            <v-card class="justify-center">
                <v-card-title
                        :class="head_color"
                        primary-title
                >
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text>
                    <h3 class="text-xs-center">{{ errores_guard }}</h3>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            v-if="band_gafete"
                            color="primary"
                            x-small
                            :loading="loading_gafete"
                            @click="download_gafete"
                    >{{$t('print_name_tag')}}
                    </v-btn>
                    <v-btn
                            color="primary"
                            @click="dialog_errores = false, errores_guard = '', band_gafete = false"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_inicio" persistent max-width="400px">
            <v-form @submit.prevent="set_caseta()">
                <v-card class="justify-center">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('selecciona_caseta')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-autocomplete
                                v-model="caseta"
                                name="caseta"
                                :items="casetas"
                                item-text="name"
                                item-value="id"
                                return-object
                                :label="$t('Casetas')"
                                :loading="loading_casetas"
                        ></v-autocomplete>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn
                                color="primary"
                                type="submit"
                        >{{ $t('aceptar') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <v-dialog v-model="dialog" persistent scrollable max-width="500">
            <v-card v-if="entrada" color="blue-grey lighten-4" class="elevation-5 center">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text v-if="Object.keys(info_invitation).length > 0 && info_invitation.type === '0'">
                    <v-flex class="text-xs-center" xs12>
                        <v-img
                                :src="info_invitation.guest_Avatar"
                                position="center center"
                                class="grey lighten-2"
                                style="border-radius: 8px; height: 450px; object-fit: contain;"
                        ></v-img>
                    </v-flex>
                    <br>
                    <v-flex class="text-xs-center" xs12>
                        <table id="datas">
                            <tr>
                                <th><h2>{{$t('Visitante')}}:</h2></th>
                                <td><h2>{{ info_invitation.guestFirstName }} {{ info_invitation.guestLastName }}</h2></td>
                            </tr>
                            <tr>
                                <th><h2>{{$t('Empresa')}}:</h2></th>
                                <td><h2>{{ info_invitation.empresa }}</h2></td>
                            </tr>
                        </table>
                    </v-flex>
                </v-card-text>
                <v-card-text v-if="Object.keys(info_invitation).length > 0 && info_invitation.type === '1'">
                    <v-flex class="text-xs-center" xs12>
                        <v-img
                                :src="info_invitation.guest.avatar"
                                position="center center"
                                class="grey lighten-2"
                                style="border-radius: 8px; height: 450px; object-fit: contain;"
                        ></v-img>
                    </v-flex>
                    <br>
                    <v-flex class="text-xs-center" xs12>
                        <table id="datas">
                            <tr>
                                <th><h2>{{$t('Visitante')}}:</h2></th>
                                <td><h2>{{ info_invitation.guest.first_name }} {{ info_invitation.guest.last_name }}</h2></td>
                            </tr>
                            <tr>
                                <th><h2>{{$t('Parque')}}:</h2></th>
                                <td><h2>{{ info_invitation.invitation.park_name }}</h2></td>
                            </tr>
                        </table>
                    </v-flex>
                </v-card-text>
                <v-card-text v-if="Object.keys(info_invitation).length > 0 && info_invitation.type === '2'">
                    <v-flex class="text-xs-center" xs12>
                        <v-img
                                :src="info_invitation.guest_avatar"
                                position="center center"
                                class="grey lighten-2"
                                style="border-radius: 8px; height: 450px; object-fit: contain;"
                        ></v-img>
                    </v-flex>
                    <br>
                    <v-flex class="text-xs-center" xs12>
                        <table id="datas">
                            <tr>
                                <th><h2>{{$t('Visitante')}}:</h2></th>
                                <td><h2>{{ info_invitation.guest_first_name }} {{ info_invitation.guest_last_name }}</h2></td>
                            </tr>
                            <tr>
                                <th><h2>{{$t('Empresa')}}:</h2></th>
                                <td><h2>{{ info_invitation.company_name }}</h2></td>
                            </tr>
                        </table>
                    </v-flex>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn large color="error" @click="dialog = false">{{ $t('cerrar')}}</v-btn>
                    <v-btn
                            large
                            color="success"
                            :loading="loading_action"
                            @click="create_acceso()"
                    >{{$t('acceso')}}
                    </v-btn>
                </v-card-actions>
            </v-card>

            <v-card v-if="salida" color="blue-grey lighten-4" class="elevation-5 center">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('form_salida')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text v-if="Object.keys(info_invitation).length > 0 && info_invitation.type === '0'">
                    <v-flex class="text-xs-center" xs12>
                        <v-img
                                :src="info_invitation.guest_Avatar"
                                position="center center"
                                class="grey lighten-2"
                                style="border-radius: 8px; height: 450px; object-fit: contain;"
                        ></v-img>
                    </v-flex>
                    <br>
                    <v-flex class="text-xs-center" xs12>
                        <table id="datas">
                            <tr>
                                <th><h2>{{$t('Visitante')}}:</h2></th>
                                <td><h2>{{ info_invitation.guestFirstName }} {{ info_invitation.guestLastName }}</h2></td>
                            </tr>
                            <tr>
                                <th><h2>{{$t('Empresa')}}:</h2></th>
                                <td><h2>{{ info_invitation.empresa }}</h2></td>
                            </tr>
                        </table>
                    </v-flex>
                </v-card-text>
                <v-card-text v-if="Object.keys(info_invitation).length > 0 && info_invitation.type === '1'">
                    <v-flex class="text-xs-center" xs12>
                        <v-img
                                :src="info_invitation.guest.avatar"
                                position="center center"
                                class="grey lighten-2"
                                style="border-radius: 8px; height: 450px; object-fit: contain;"
                        ></v-img>
                    </v-flex>
                    <br>
                    <v-flex class="text-xs-center" xs12>
                        <table id="datas">
                            <tr>
                                <th><h2>{{$t('Visitante')}}:</h2></th>
                                <td><h2>{{ info_invitation.guest.first_name }} {{ info_invitation.guest.last_name }}</h2></td>
                            </tr>
                            <tr>
                                <th><h2>{{$t('Parque')}}:</h2></th>
                                <td><h2>{{ info_invitation.invitation.park_name }}</h2></td>
                            </tr>
                        </table>
                    </v-flex>
                </v-card-text>
                <v-card-text v-if="Object.keys(info_invitation).length > 0 && info_invitation.type === '2'">
                    <v-flex class="text-xs-center" xs12>
                        <v-img
                                :src="info_invitation.guest_avatar"
                                position="center center"
                                class="grey lighten-2"
                                style="border-radius: 8px; height: 450px; object-fit: contain;"
                        ></v-img>
                    </v-flex>
                    <br>
                    <v-flex class="text-xs-center" xs12>
                        <table id="datas">
                            <tr>
                                <th><h2>{{$t('Visitante')}}:</h2></th>
                                <td><h2>{{ info_invitation.guest_first_name }} {{ info_invitation.guest_last_name }}</h2></td>
                            </tr>
                            <tr>
                                <th><h2>{{$t('Empresa')}}:</h2></th>
                                <td><h2>{{ info_invitation.company_name }}</h2></td>
                            </tr>
                        </table>
                    </v-flex>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn large color="error" @click="dialog = false">{{ $t('cerrar')}}</v-btn>
                    <v-btn
                            large
                            color="success"
                            :loading="loading_action"
                            @click="update_acceso()"
                    >{{$t('registrar_salida')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-container class="my-1">
            <v-card class="my-2">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('current_invitations')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon :loading="loading_list" @click="get_active_invitations()">
                        <v-icon>refresh</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout row wrap class="my-4" align-center justify-center fill-height>
                        <v-flex xs12>
                            <v-card-title class="justify-center">
                                <v-text-field
                                        outlined
                                        clearable
                                        v-model="search"
                                        append-icon="mdi-magnify"
                                        :label="$t('Buscar')"
                                        :placeholder="$t('Buscar')"
                                ></v-text-field>
                            </v-card-title>
                        </v-flex>
                        <v-flex xs12>
                            <v-data-table
                                    :headers="headers"
                                    :loading="loading_list"
                                    :items="table_items"
                                    :search="search"
                                    :rows-per-page-text="$t('filas_por_pagina')"
                                    :rows-per-page-items="[
                                        {text: '5', value: 5},
                                        {text: '10', value: 10},
                                        {text: '25', value: 25},
                                        {text: this.$t('todos'), value: -1}
                                    ]"
                                    class="elevation-1"
                                    :no-data-text="$t('no_registros_invit')"
                                    :no-results-text="`${$t('ningun_resultado_1')} &quot;${search}&quot; ${$t('ningun_resultado_2')}`"
                            >
                                <template v-slot:items="props">
                                    <td class="justify-center layout px-0">
                                        <v-btn
                                                color="primary"
                                                class="mr-2"
                                                @click="open_invitation(props.item)"
                                                :loading="loading_action && qr_code === props.item.qr_code"
                                        >
                                            {{$t('entradas_salidas')}}
                                        </v-btn>
                                    </td>
                                    <td>
                                        <v-chip :color="props.item.chipColor" text-color="white" small>
                                            {{ props.item.tipo }}
                                        </v-chip>
                                    </td>
                                    <td>{{ props.item.fullName }}</td>
                                    <td>{{ props.item.linkedCompany }}</td>
                                    <td>{{ props.item.hostName }}</td>
                                    <td>{{ props.item.fechaEnvio }}</td>
                                    <td>{{ props.item.expiration }}</td>
                                    <td>{{ props.item.qr_code }}</td>
                                </template>
                                <template v-slot:no-results>
                                    <div class="text-xs-center pa-4 grey--text">
                                        <v-icon large color="grey lighten-1">search_off</v-icon>
                                        <div class="subheading mt-2">
                                            {{$t('ningun_resultado_1')}} <strong>"{{ search }}"</strong> {{$t('ningun_resultado_2')}}
                                        </div>
                                    </div>
                                </template>
                                <template v-slot:no-data>
                                    <div class="text-xs-center pa-4 grey--text">
                                        <v-icon large color="grey lighten-1">inbox</v-icon>
                                        <div class="subheading mt-2">{{ $t('no_registros_invit') }}</div>
                                    </div>
                                </template>
                                <template v-slot:pageText="props">
                                    {{props.rowsPerPage}}
                                    {{$t('Invitaciones')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
    import axios from 'axios'
    import store from '@/store'
    import { mapState, mapGetters } from 'vuex'
    import jsPDF from 'jspdf'

    export default {
        name: 'active_invitations_park',
        data () {
            return {
                headers: [
                    { text: this.$t('acciones'), align: 'center', sortable: false, value: 'details' },
                    { text: this.$t('Tipo'), align: 'left', sortable: true, value: 'tipo' },
                    { text: this.$t('Visitante'), align: 'left', sortable: true, value: 'fullName' },
                    { text: 'Empresa ligada', align: 'left', sortable: true, value: 'linkedCompany' },
                    { text: 'Anfitrion / Destino', align: 'left', sortable: true, value: 'hostName' },
                    { text: this.$t('fecha_envio'), align: 'left', sortable: true, value: 'fechaEnvio' },
                    { text: this.$t('fecha_expiracion'), align: 'left', sortable: true, value: 'expiration' },
                    { text: this.$t('qr_code'), align: 'left', sortable: true, value: 'qr_code' }
                ],
                active_invitations: [],
                search: '',
                loading_list: false,
                loading_action: false,
                loading_casetas: false,
                loading_gafete: false,
                dialog: false,
                dialog_inicio: false,
                dialog_errores: false,
                entrada: false,
                salida: false,
                qr_code: '',
                info_invitation: [],
                data_access: [],
                casetas: [],
                caseta: 0,
                errores_guard: '',
                head_color: '',
                band_gafete: false
            }
        },
        created () {
            this.get_casetas()
            this.get_active_invitations()
            if (localStorage.getItem('id_caseta') === null) {
                this.dialog_inicio = true
            }
        },
        computed: {
            ...mapGetters(['getProfile']),
            ...mapState(['caseta_vigilante']),
            table_items () {
                return this.active_invitations.map(inv => {
                    const type = inv.type
                    const qrCode = type === '1' ? inv.code : inv.qr_code
                    return {
                        ...inv,
                        qr_code: qrCode,
                        tipo: this.get_type_label(type),
                        chipColor: this.get_type_color(type),
                        fullName: this.get_guest_name(inv),
                        linkedCompany: this.get_linked_company(inv),
                        hostName: this.get_host_name(inv),
                        fechaEnvio: this.get_date(inv),
                        expiration: this.get_expiration(inv)
                    }
                })
            }
        },
        methods: {
            get_active_invitations () {
                this.loading_list = true
                const today = new Date()
                const year = today.getFullYear()
                const month = today.getMonth() + 1
                const day = today.getDate()
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/InvitationPark/active-invitations/' + year + '/' + month + '/' + day + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }

                axios(config)
                    .then(response => {
                        if (response.status === 204 || !Array.isArray(response.data)) {
                            this.active_invitations = []
                            return
                        }
                        this.active_invitations = response.data
                    })
                    .catch(error => {
                        this.active_invitations = []
                        this.head_color = 'red display-1 text--primary justify-center'
                        if (error && error.response && error.response.status === 400 && error.response.data && error.response.data.detail) {
                            this.errores_guard = error.response.data.detail
                        } else {
                            this.errores_guard = 'No se pudieron obtener las invitaciones vigentes.'
                        }
                        this.dialog_errores = true
                    })
                    .finally(() => {
                        this.loading_list = false
                    })
            },
            get_casetas () {
                this.loading_casetas = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/GuardHouse/ListCreate/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }
                axios(config)
                    .then(response => {
                        this.casetas = response.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
                    .finally(() => {
                        this.loading_casetas = false
                    })
            },
            set_caseta () {
                if (this.caseta && this.caseta.id > 0) {
                    localStorage.setItem('id_caseta', this.caseta.id)
                    localStorage.setItem('id_parque', this.caseta.park)
                    this.dialog_inicio = false
                }
            },
            open_invitation (item) {
                this.qr_code = item.qr_code
                this.get_invitation()
            },
            get_invitation () {
                if (this.qr_code === '') return

                this.loading_action = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/InvitationPark/all_invitations/' + this.qr_code,
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }

                axios(config)
                    .then(response => {
                        this.info_invitation = response.data
                        this.is_access_in_out_both()
                    })
                    .catch(error => {
                        this.loading_action = false
                        if (error.request.status === 404) {
                            this.clear_state()
                            this.errores_guard = this.$t('mensaje_qr_no_valido')
                            this.head_color = 'red display-1 text--primary justify-center'
                            this.dialog_errores = true
                        }
                        if (error.request.status === 401) {
                            this.clear_state()
                            this.errores_guard = this.$t('mensaje_qr_no_parque_empresa')
                            this.head_color = 'red display-1 text--primary justify-center'
                            this.dialog_errores = true
                        }
                    })
            },
            is_access_in_out_both () {
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/InvitationAccessPark/QrCode/' + this.qr_code,
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }

                axios(config)
                    .then(response => {
                        this.loading_action = false
                        if (this.info_invitation.type === '0') {
                            this.resolve_access_status_for_company(response)
                        } else if (this.info_invitation.type === '1') {
                            this.resolve_access_status_for_park(response)
                        } else if (this.info_invitation.type === '2') {
                            this.resolve_access_status_for_shipment(response)
                        }
                    })
                    .catch(error => {
                        this.loading_action = false
                        console.log(error)
                    })
            },
            resolve_access_status_for_company (response) {
                if (this.info_invitation.typeInv !== 2) {
                    if (response.request.status === 204) {
                        this.show_entrada()
                    }
                    if (response.request.status === 200) {
                        if (Object.keys(response.data).length > 0 && response.data.status === 1) {
                            this.data_access = response.data
                            this.show_salida()
                        }
                        if (response.data.status === 2) {
                            this.show_completed_message()
                        }
                    }
                } else {
                    if (response.request.status === 204) {
                        this.show_entrada()
                    } else if (response.data.status === 1) {
                        this.data_access = response.data
                        this.show_salida()
                    } else {
                        var fechaLocal = new Date(this.get_current_date())
                        const readableDate = response.data.dateTime_EntranceAccess.substring(3, 6) + response.data.dateTime_EntranceAccess.substring(0, 2) + response.data.dateTime_EntranceAccess.substring(5, 10)
                        var fechaAccesoEntrada = new Date(readableDate)
                        if (fechaAccesoEntrada.getTime() !== fechaLocal.getTime()) {
                            this.show_entrada()
                        } else {
                            this.show_completed_message()
                        }
                    }
                }
            },
            resolve_access_status_for_park (response) {
                if (this.info_invitation.invitation.typeInv !== 2) {
                    if (response.request.status === 204) {
                        this.show_entrada()
                    }
                    if (response.request.status === 200) {
                        if (Object.keys(response.data).length > 0 && response.data.status === 1) {
                            this.data_access = response.data
                            this.show_salida()
                        }
                        if (response.data.status === 2) {
                            this.show_completed_message()
                        }
                    }
                } else {
                    if (response.request.status === 204) {
                        this.show_entrada()
                    } else if (response.data.status === 1) {
                        this.data_access = response.data
                        this.show_salida()
                    } else {
                        var fechaLocal = new Date(this.get_current_date())
                        const readableDate = response.data.dateTime_EntranceAccess.substring(3, 6) + response.data.dateTime_EntranceAccess.substring(0, 2) + response.data.dateTime_EntranceAccess.substring(5, 10)
                        var fechaAccesoEntrada = new Date(readableDate)
                        if (fechaAccesoEntrada.getTime() !== fechaLocal.getTime()) {
                            this.show_entrada()
                        } else {
                            this.show_completed_message()
                        }
                    }
                }
            },
            resolve_access_status_for_shipment (response) {
                if (response.request.status === 204) {
                    this.show_entrada()
                }
                if (response.request.status === 200) {
                    if (Object.keys(response.data).length > 0 && response.data.status === 1) {
                        this.data_access = response.data
                        this.show_salida()
                    }
                    if (response.data.status === 2) {
                        this.show_completed_message()
                    }
                }
            },
            show_entrada () {
                this.entrada = true
                this.salida = false
                this.dialog = true
            },
            show_salida () {
                this.entrada = false
                this.salida = true
                this.dialog = true
            },
            show_completed_message () {
                this.clear_state()
                this.head_color = 'orange display-1 text--primary justify-center'
                this.errores_guard = this.$t('mensaje_acceso_completo')
                this.dialog_errores = true
            },
            activate_device (type = 'entrada') {
                const idParque = localStorage.getItem('id_parque')
                
                if (!idParque) {
                    console.warn('idParque no disponible')
                    return
                }

                // UUIDs para entrada y salida
                const uuids = {
                    entrada: 'ff46d2af-8b16-4551-841e-931535b80018',
                    salida: '3c7c1dc6-0db5-4ad5-b5e0-241e3944fa19'
                }

                const uuid = uuids[type] || uuids.entrada

                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/Devices/industrial-park-device/activate/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        uuid: uuid,
                        idParque: parseInt(idParque)
                    }
                }

                axios(config)
                    .then(response => {
                        console.log(`Dispositivo activado (${type}):`, response.data)
                    })
                    .catch(error => {
                        console.error(`Error al activar dispositivo (${type}):`, error)
                    })
            },
            create_acceso () {
                this.loading_action = true
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/InvitationAccessPark/create/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        guardhouse: localStorage.getItem('id_caseta'),
                        qr_code: this.qr_code
                    }
                }
                axios(config)
                    .then(() => {
                        this.loading_action = false
                        this.dialog = false
                        this.activate_device('entrada')
                        this.get_active_invitations()
                        this.head_color = 'green display-1 text--primary justify-center'
                        this.errores_guard = this.$t('mensaje_alta_acceso_in')
                        this.dialog_errores = true
                    })
                    .catch(error => {
                        this.loading_action = false
                        this.dialog = false
                        this.head_color = 'red display-1 text--primary justify-center'
                        if (Array.isArray(error.response.data) && error.response.data.length > 1 && error.response.data[1].detail) {
                            this.errores_guard = error.response.data[1].detail
                        } else if (error.response.data.detail) {
                            if (error.response.data.code === '05' && this.info_invitation.type === '2') {
                                this.errores_guard = 'Pendiente de autorizacion de supervisor'
                            } else {
                                this.errores_guard = error.response.data.detail
                            }
                        } else {
                            this.errores_guard = this.$t('msg_error')
                        }
                        this.dialog_errores = true
                    })
            },
            update_acceso () {
                this.loading_action = true
                let URL = ''
                if (this.info_invitation.type === '0') {
                    URL = 'https://empresa-service.intrare.app/InvitationAccessPark/updateAccessCodePark/' + this.qr_code + '/'
                } else {
                    URL = 'https://empresa-service.intrare.app/InvitationAccessPark/updateAccessInvitationPark/' + this.qr_code + '/'
                }
                const config = {
                    method: 'PATCH',
                    url: URL,
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }
                axios(config)
                    .then(() => {
                        this.loading_action = false
                        this.dialog = false
                        this.activate_device('salida')
                        this.get_active_invitations()
                        this.head_color = 'green display-1 text--primary justify-center'
                        this.errores_guard = this.$t('mensaje_alta_acceso_out')
                        this.dialog_errores = true
                    })
                    .catch(error => {
                        this.loading_action = false
                        if (error.response && error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
                            this.errores_guard = error.response.data.detail || this.$t('msg_error')
                            this.head_color = 'red display-1 text--primary justify-center'
                            this.dialog_errores = true
                        }
                    })
            },
            get_current_date () {
                var today = new Date()
                var dd = today.getDate()
                var mm = today.getMonth() + 1
                var yyyy = today.getFullYear()
                if (dd < 10) dd = '0' + dd
                if (mm < 10) mm = '0' + mm
                return mm + '/' + dd + '/' + yyyy
            },
            clear_state () {
                this.dialog = false
                this.entrada = false
                this.salida = false
                this.qr_code = ''
                this.info_invitation = []
                this.data_access = []
            },
            get_type_label (type) {
                if (type === '0') return 'Empresa'
                if (type === '1') return 'Parque'
                if (type === '2') return 'Embarque'
                return 'N/A'
            },
            get_type_color (type) {
                if (type === '0') return 'teal'
                if (type === '1') return 'indigo'
                if (type === '2') return 'deep-orange darken-2'
                return 'grey'
            },
            get_guest_name (inv) {
                if (inv.type === '1') return `${inv.guest.first_name} ${inv.guest.last_name}`
                if (inv.type === '0') return `${inv.guestFirstName} ${inv.guestLastName}`
                if (inv.type === '2') return `${inv.guest_first_name} ${inv.guest_last_name}`
                return 'N/A'
            },
            get_linked_company (inv) {
                if (inv.type === '0') return inv.empresa || 'N/A'
                if (inv.type === '2') return inv.company_name || 'N/A'
                if (inv.type === '1' && inv.invitation) return inv.invitation.park_name || 'N/A'
                return 'N/A'
            },
            get_host_name (inv) {
                if (inv.type === '1' && inv.host) return `${inv.host.first_name} ${inv.host.last_name}`
                if (inv.type === '0') return inv.areaName || 'N/A'
                if (inv.type === '2') return `${inv.host_first_name || ''} ${inv.host_last_name || ''}`.trim() || 'N/A'
                return 'N/A'
            },
            get_date (inv) {
                if (inv.type === '1' && inv.invitation) return `${inv.invitation.dateInv || 'N/A'} ${inv.invitation.timeInv || ''}`.trim()
                if (inv.type === '0') return `${inv.dateInv || 'N/A'} ${inv.timeInv || ''}`.trim()
                if (inv.type === '2') return `${inv.window_date || 'N/A'} ${inv.window_time || ''}`.trim()
                return 'N/A'
            },
            get_expiration (inv) {
                if (inv.type === '1' && inv.invitation) return inv.invitation.dateInv || 'N/A'
                if (inv.type === '0') return inv.expiration || 'N/A'
                if (inv.type === '2') return '-'
                return 'N/A'
            },
            xOffset (pdf, text) {
                return (pdf.internal.pageSize.width / 2) - (pdf.getStringUnitWidth(text) * pdf.internal.getFontSize() / 2)
            },
            download_gafete () {
                if (!this.info_invitation.logoEmpresa || !this.info_invitation.guestFirstName) {
                    return
                }
                this.loading_gafete = true
                const toDataUrl = (url, callback) => {
                    const xhr = new XMLHttpRequest()
                    xhr.onload = () => {
                        const reader = new FileReader()
                        reader.onloadend = () => {
                            callback(reader.result)
                        }
                        reader.readAsDataURL(xhr.response)
                    }
                    xhr.open('GET', url)
                    xhr.responseType = 'blob'
                    xhr.send()
                }

                toDataUrl(this.info_invitation.logoEmpresa, (logo_guest) => {
                    var pdf = new jsPDF('l', 'in', [288, 144])
                    pdf.setDrawColor(0)
                    pdf.setFontSize(9)
                    pdf.text(this.$t('fecha_hora_acceso'), 2.3, 0.4)
                    pdf.setLineWidth(0.02)
                    pdf.line(2.3, 0.42, 3.7, 0.42)
                    pdf.setFontStyle('normal')
                    pdf.text(this.info_invitation.dateInv + ' ' + this.info_invitation.timeInv, 2.7, 0.6)
                    pdf.setFontSize(14)
                    pdf.line(this.xOffset(pdf, this.$t('Visitante').toUpperCase()), 0.92, 2.6, 0.92)
                    pdf.setFontStyle('bold')
                    pdf.text(this.$t('Visitante').toUpperCase(), this.xOffset(pdf, this.$t('Visitante').toUpperCase()), 0.9)
                    pdf.setFontSize(16)
                    pdf.setFontStyle('normal')
                    pdf.text(this.info_invitation.guestFirstName + ' ' + this.info_invitation.guestLastName, this.xOffset(pdf, this.info_invitation.guestFirstName + ' ' + this.info_invitation.guestLastName), 1.2)
                    pdf.line(this.xOffset(pdf, this.$t('Anfitrion').toUpperCase()), 1.47, 2.6, 1.47)
                    pdf.setFontSize(14)
                    pdf.setFontStyle('bold')
                    pdf.text(this.$t('Anfitrion').toUpperCase(), this.xOffset(pdf, this.$t('Anfitrion').toUpperCase()), 1.45)
                    pdf.setFontSize(16)
                    pdf.setFontStyle('normal')
                    pdf.text(this.info_invitation.hostFirstName + ' ' + this.info_invitation.hostLastName, this.xOffset(pdf, this.info_invitation.hostFirstName + ' ' + this.info_invitation.hostLastName), 1.70)
                    pdf.setTextColor('#000000')
                    pdf.addImage(logo_guest, 'WEBP', 0.25, 0.25, 0.9, 0.7)
                    pdf.save('gafete.pdf')
                    this.loading_gafete = false
                })
            }
        }
    }
</script>

<style scoped>
    #datas {
        font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    #datas td, #datas th {
        padding: 8px;
    }

    #datas tr:nth-child(even){background-color: #f2f2f2;}

    #datas tr:hover {background-color: #ddd;}

    #datas th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #002b48;
        color: white;
    }
</style>
